var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Show"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0008 5.64062C8.66921 5.64062 7.58984 6.71968 7.58984 8.05262C7.58984 9.38441 8.66906 10.4636 10.0008 10.4636C11.3329 10.4636 12.4128 9.3841 12.4128 8.05262C12.4128 6.71999 11.3328 5.64062 10.0008 5.64062ZM6.08984 8.05262C6.08984 5.89157 7.84048 4.14062 10.0008 4.14062C12.1609 4.14062 13.9128 5.89126 13.9128 8.05262C13.9128 10.2131 12.1607 11.9636 10.0008 11.9636C7.84063 11.9636 6.08984 10.2128 6.08984 8.05262Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 54 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83283 8C2.41125 9.15908 3.35927 10.6563 4.65568 11.8953C6.0698 13.2467 7.85208 14.25 10 14.25C12.1479 14.25 13.9302 13.2467 15.3443 11.8953C16.6407 10.6563 17.5888 9.15908 18.1672 8C17.5888 6.84092 16.6407 5.34365 15.3443 4.10471C13.9302 2.75327 12.1479 1.75 10 1.75C7.85208 1.75 6.0698 2.75327 4.65568 4.10471C3.35927 5.34365 2.41125 6.84092 1.83283 8ZM3.61932 3.02029C5.21354 1.49673 7.34792 0.25 10 0.25C12.6521 0.25 14.7865 1.49673 16.3807 3.02029C17.9708 4.53997 19.0696 6.37553 19.6796 7.68284C19.7735 7.88387 19.7735 8.11613 19.6796 8.31716C19.0696 9.62447 17.9708 11.46 16.3807 12.9797C14.7865 14.5033 12.6521 15.75 10 15.75C7.34792 15.75 5.21354 14.5033 3.61932 12.9797C2.02916 11.46 0.93044 9.62447 0.320363 8.31716C0.226546 8.11613 0.226546 7.88387 0.320363 7.68284C0.93044 6.37553 2.02916 4.53997 3.61932 3.02029Z",
    fill: "#667085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.37a558e5cb6ad0d9c4f75000b8a6feee.svg";
export { ForwardRef as ReactComponent };